module.exports = __webpack_public_path__ + "img/kommune-627.678fead7.svg";